import { Button, Col, Form, Row } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CommonTab from '../../../../../../shared/components/tabs/CommonTab';
import { GUTTOR_SPACE_SMALL, VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import { useSetDetailInForm } from '../../../../../../shared/hooks/setDetailInForm/useSetDetailInForm';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import { RootState } from '../../../../../../store';
import { setGoToNext, setIPNumberPopup, setsubmitDisabled } from '../../../../../../store/actions/newAdmissionAction';
import { getNHCXResponse } from '../../../../../../store/actions/nhcxAction';
import { AdmissionForm } from '../../../../../../store/models/newAdmissionModel';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { checkAndFormatMomentObject } from '../../../../../../utils/dateTimeUtils';
import { centeredNotification } from '../../../../../../utils/utility';
import { customGTMEvent, getIsPageNameDetail, prepareBillDetail } from '../../../service/crmUtils';
import { AdmissionContext } from '../../AdmissionContext';

const CustomFormStepper = ({
  form, buddhimedForm, detailNav = (): void => { }, commonTabNavigationEnabled = true,
  setIsSubmitDisabled = (): void => { },
  selectedTab,
  formValue = {},
  setSelectedTab = (): void => { },
  setFormValue,
  isLoading,
  onValueChange = (): void => { },
  action = (): void => { },
  tabSwitchExtra,
  className = '',
  taskForAdmissionValBeforeUpdate = (): void => {},
  isVisible,
  isNewForm,
}: any): ReactElement | null => {
  const { goToNext, selectedDraft, isPageChangeAllowed, isIPNumberPopUpEnabled,
     isAbhaVerified, admissionFormVal, isDraftSelected, selectedPackage, submitDisabled, draftFormValidated} =
  useSelector((state: RootState): any => state.newAdmission);
  const { claimDetails }: any = useSelector((state: RootState): any => state.admissionDetails);
  const { payer: {shortName} } = useSelector((state: RootState): any => state.payerList);
  const { ipoCorelationId, memberCorelationId } = useSelector((state: RootState): NHCXState => state.nhcx);
  const commonTabRef = useRef<any>();
  const dispatch = useDispatch();
  const history = useHistory();
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const [ipPopupClicked, setIpPopupClicked] = useState(false);

  const [aForm] = Form.useForm();
  if (!form) {
    form = aForm;
  }

  const claimDetailBackup = useSetDetailInForm(form);
  const getNavIndex = (id: string): number =>
    detailNav.findIndex((tab: any): boolean => tab.tabName === id);

  const setSelectedTabIndex = (): void => {
    commonTabRef?.current?.setSelectedTabIndex(detailNav[selectedTab].tabName);
  };

  const prev = async (): Promise<void> => {
    await form.validateFields().then((): void => {
      detailNav[selectedTab].isValidated = true;
    }).catch((): void => {
      detailNav[selectedTab].isValidated = false;
    });
    if (isPageChangeAllowed) { // removed validation of form while going to previous tab (IPP-3511)
      setIpPopupClicked(false);
      postFormValidation(form, selectedTab - 1);
      } else {
        centeredNotification('Please select OK or close the Alert Box');
      }

  };

  const updateAdmissionForm = (formVal: any): void => {
    let newFormVal: any = {
      ...formValue as AdmissionForm, ...{
        [detailNav[selectedTab].formKey]: formVal,
      },
    };
    if (setFormValue) {
      newFormVal = taskForAdmissionValBeforeUpdate(newFormVal);
      dispatch(setFormValue(newFormVal));
    }
  };

  const next = async (formVal: any): Promise<void> => {
    if (selectedTab === 0 && !formVal.inPatientNumber && !isIPNumberPopUpEnabled
      && !ipPopupClicked && !getIsPageNameDetail(history.location.pathname) && (shortName === 'MATPA' || shortName === 'RHITPA')) {
        setIpPopupClicked(true);
      dispatch(setIPNumberPopup(true));
      return;
    }
    dispatch(setIPNumberPopup(false));
    if (!getIsPageNameDetail(history.location.pathname)) {
      await form?.validateFields().then((): void => {
        detailNav[selectedTab].isValidated = true;
      }).catch((): void => {
        detailNav[selectedTab].isValidated = false;
      });
      const readyToSwitch = true;
      if (readyToSwitch && isPageChangeAllowed) {
        detailNav[selectedTab].isValidated = true;
        detailNav[selectedTab].isTouched = true;
        updateAdmissionForm(formVal);
        setSelectedTab(selectedTab + 1);
        sendGAEvent(formVal);
      }
      if (!isPageChangeAllowed) {
        centeredNotification('"Please select OK or close the Alert Box"');
      }
    } else {
      setSelectedTab(selectedTab + 1);
    }
  };

  const setEventName = (): string[] => {
    const flowName: string|undefined  = claimDetails?.nextAllowStatus?.[0];
    let eventNames: string[];
    switch (flowName) {
      case 'ENHANCEMENT':
      case 'DISCHARGE':
        eventNames = ['Enhance- Edit Member Details and Click Next', 'Enhance- Edit Treatment Details and Click Next'];
        break;
      case 'CASHLESSSUMBIT':
        eventNames = ['WA_SETTLEMENT_INITIATION_MEMBER_DETAILS_ENTERED', 'WA_SETTLEMENT_INITIATION_TREATMENT_DETAILS_ENTERED'];
        break;
      case 'SUBMITINFO':
        eventNames = ['WA_QUERY_MEMBER_DETAILS_ENTERED', 'WA_QUERY_TREATMENT_DETAILS_ENTERED'];
        break;
      case undefined:
      case null :
        eventNames = ['WA_MEMBER_DETAILS_ENTERED', 'WA_TREATMENT_DETAILS_ENTERED'];
        break;
      default:
        eventNames = ['', ''];
    }
    return eventNames;
  };

  const sendGAEvent = (formval: any): void => {
     let dataToSend = {};
     if (!formval) {
       return;
     }
     if (selectedTab === 0) {
       const {
           fullName,
           mobile,
           emailId,
           healthId,
           memberId,
           corporateName,
           employeeId,
           insurerName,
           payer,
           policyNumber,
           inPatientNumber,
         } = formval;
         dataToSend = {
           event : setEventName()[0] ,
           fullName,
           mobile,
           emailId,
           healthId,
           memberId,
           corporateName,
           employeeId,
           insurerName,
           payer,
           policyNumber,
           inPatientNumber,
         };
     } else if (selectedTab === 1) {
       const {
         dateOfAdmission,
         dateOfDischarge,
         proposedLineOfTreatment,
         treatment,
         diagnosis,
         doctorName,
         doctorRegNo,
         hospitalRoomType,
         isDeathCase,
         otherAilment,
         dateOfInjury,
         isItARta,
         injuryOrDeseaseCaused,
         testConductedToEstablishedThis,
         isReportedToPolice,
         firNumber,
       } = formval;

       dataToSend = {
         event: setEventName()[1],
         dateOfAdmission: checkAndFormatMomentObject(dateOfAdmission),
         dateOfDischarge : checkAndFormatMomentObject(dateOfDischarge),
         proposedLineOfTreatment,
         treatment,
         diagnosis,
         doctorName,
         doctorRegNo,
         hospitalRoomType,
         isDeathCase,
         otherAilment,
         dateOfInjury : checkAndFormatMomentObject(dateOfInjury),
         isItARta,
         injuryOrDeseaseCaused,
         testConductedToEstablishedThis,
         isReportedToPolice,
         firNumber,
       };
     }
    customGTMEvent(dataToSend);
  };

  useEffect((): void => {
    if (goToNext) {
      if (
        selectedTab < detailNav.length - 1 &&
        selectedDraft?.statusName !== 'Settlement Initiated'
      ) {
        onChangeSeletedTab(detailNav[selectedTab + 1].tabName);
      }
      dispatch(setGoToNext(false));
    }
  }, [goToNext, selectedDraft]);

  useEffect((): any => {
    onFormChange('stayLength', true);

  }, [form.getFieldValue(['stayLength'])]);

  useEffect((): any => {
    const parsedDraftData = selectedDraft?.rawDraft?.length > 0 ? JSON?.parse(selectedDraft?.rawDraft) : {};
    const abhaVerification = isDraftSelected ? !parsedDraftData?.draftAbhaVerified : !isAbhaVerified;
    if (abhaVerification) {
      admissionFormVal.customerDetail.healthId = '';
    } else {
      setTimeout((): any => {
        form.setFieldsValue({ healthId: admissionFormVal.customerDetail.healthId });
      }, 700);
    }

    if (isNHCXEnabledProvider && selectedTab > 0 && selectedTab <= 2) {
      if (ipoCorelationId != null || memberCorelationId != null) {
        dispatch(getNHCXResponse());
      }
    }

  }, [selectedTab]);

  const onChangeSeletedTab = async (toTab: string, fromTab?: string): Promise<void> => {
    if (commonTabNavigationEnabled) { // added a parameter to get the current tab from which tab switch happens
      const startingTab = 'Member Details';
      const nextSelectedTabIndex = getNavIndex(toTab);
      const currentTabIndex = getNavIndex(fromTab || startingTab);
      const isForwardSwitch = currentTabIndex < nextSelectedTabIndex;
      if (!getIsPageNameDetail(history.location.pathname)) {
        if (!isForwardSwitch) {
          await form.validateFields().then((): void => {
            detailNav[currentTabIndex].isValidated = true;

          }).catch((): void => {
            detailNav[currentTabIndex].isValidated = false;
          });
          // condition to check whether the tab switch is backward to prevent form Validation
          const readyToSwitch = true;               // removed validation of form while going to previous tab (IPP-3511)
          if (readyToSwitch && isPageChangeAllowed) {
            postFormValidation(form, nextSelectedTabIndex);
            setIpPopupClicked(false);
          }
          if (!isPageChangeAllowed) {
            centeredNotification('"Please select OK or close the Alert Box"');
          }
        } else {
          if (nextSelectedTabIndex - 2 === currentTabIndex) {
            // when member detail to bill detail switch occurs
            if (detailNav[nextSelectedTabIndex]?.isTouched) {
            if (detailNav[nextSelectedTabIndex - 1]?.isValidated) {
             await form.validateFields().then((): void => {
                detailNav[selectedTab].isValidated = true;
                const readyToSwitch = true;
                if (readyToSwitch && isPageChangeAllowed) {
                  postFormValidation(form, nextSelectedTabIndex);
                }
                if (!isPageChangeAllowed) {
                  centeredNotification('"Please select OK or close the Alert Box"');
                }
              }).catch((): void => {
                detailNav[selectedTab].isValidated = false;
              });
            } else {
            postFormValidation(form, nextSelectedTabIndex - 1);
            centeredNotification('Please fill the required fields in Treatment Details to switch to Bill Details tab');
          }
        }
          } else {
            await form?.validateFields().then((): void => {
              detailNav[selectedTab].isValidated = true;
              detailNav[selectedTab].isTouched = true;
              const readyToSwitch = true;
              if (selectedTab === 0 && !form.getFieldValue('inPatientNumber') && !isIPNumberPopUpEnabled
                && !ipPopupClicked && !getIsPageNameDetail(history.location.pathname) &&
                (shortName === 'MATPA' || shortName === 'RHITPA')) {
                  setIpPopupClicked(true);
                dispatch(setIPNumberPopup(true));
                return;
              }
              dispatch(setIPNumberPopup(false));
              if (detailNav[nextSelectedTabIndex - 1]?.isValidated && readyToSwitch && isPageChangeAllowed) {
                postFormValidation(form, nextSelectedTabIndex);
              }
              if (!isPageChangeAllowed) {
                centeredNotification('"Please select OK or close the Alert Box"');
              }
            }).catch((): void => {
              detailNav[selectedTab].isValidated = false;
            });
          }

        }
      } else {
        setSelectedTab(nextSelectedTabIndex);
      }
    }
  };

  const postFormValidation = (formInstance: any, nextSelectedTabIndex: number): void => {
    const updatedFormValue = formInstance.getFieldsValue();
    updateAdmissionForm({ ... updatedFormValue});
    setSelectedTab(nextSelectedTabIndex);
  };

  const onFormChange = async (ele: any, isMemberChange?: boolean): Promise<any> => {
    if (!isMemberChange) {
      onValueChange(ele);
    }
    const isAllTabToched = detailNav.every((tab: any): any => tab.isTouched);
    if (!isDraftSelected) {
      if (isAllTabToched) {
       setTimeout(async (): Promise<any> => {
       await form?.validateFields().then((): any => {
        dispatch(setsubmitDisabled(false));
       }).catch((): any => {
        dispatch(setsubmitDisabled(true));
       });
      }, 1000);
    }
  } else { // draft cases
    if (draftFormValidated || isAllTabToched) {
    setTimeout(async (): Promise<any> => {
      await form?.validateFields().then((): any => {
       dispatch(setsubmitDisabled(false));
      }).catch((): any => {
       dispatch(setsubmitDisabled(true));
      });
     }, 1000);

  }
    }
  };

  useEffect((): void => {
    setSelectedTab(0);
    if (isDraftSelected && !submitDisabled ) {
      setTimeout(async (): Promise<any> => {
     await form?.validateFields().then((): any => {
      dispatch(setsubmitDisabled(false));
     }).catch((): any => {
      dispatch(setsubmitDisabled(true));
     });
    }, 1000);

    }
  }, []);

  useEffect((): void => {
    const {billDetail} = admissionFormVal;
    const billItems = prepareBillDetail(billDetail, selectedPackage);
    if (!(selectedPackage?.length > 0) && billItems.length === 0) {
      if (detailNav?.length > 2) {
      detailNav[2].isValidated = false;
      }
    }
  }, [selectedPackage]);

  useEffect((): void => {
    if (selectedTab >= 0 && selectedTab < detailNav.length) {
      detailNav[selectedTab].isTouched = true;
      // const isAllTabValidated = detailNav.every((tab: any): boolean => tab.isTouched);
      // setIsSubmitDisabled(!isAllTabValidated);
      form.setFieldsValue(formValue[detailNav[selectedTab].formKey]);
      setSelectedTabIndex();
    }
  }, [selectedTab]);

  if ((selectedTab === undefined) || (selectedTab < 0 || selectedTab > detailNav.length)) {
    return <React.Fragment/>;
  }
  const { formComponent: FormComponent, beforeFormComponent: IndependentComponent } = detailNav[selectedTab];
  if (isNewForm && !isVisible) {
    return null;
  }

  return <React.Fragment>
    <CommonTab
      tabType="card"
      defaultPage={detailNav[selectedTab].tabName}
      nestedNav={detailNav}
      onTabSelectHandler={onChangeSeletedTab}
      isUpdateTab={false}
      ref={commonTabRef} />
    <div className={`sticky-panel scrollbar ${className}`}>
      {
        IndependentComponent && <IndependentComponent form={form} detailNav={detailNav} />
      }
      {
        <Form
          layout="vertical"
          form={form}
          validateMessages={VALIDATE_MESSAGES}
          onFinish={next}
          requiredMark="optional"
          onValuesChange={onFormChange}
          scrollToFirstError={true}
          noValidate={true}>
          <AdmissionContext.Provider value={{
            claimDetailBackup,
            form,
            buddhimedForm,
          }}>
            {FormComponent &&
              <FormComponent form={form} isLoading={isLoading} action={action} />
            }
          </AdmissionContext.Provider>

          <Row gutter={GUTTOR_SPACE_SMALL} className="mb-md">
            <Col md={12}>
              {
                selectedTab !== 0 &&
                  <Button
                    className="btn-cancel"
                    onClick={prev}
                    data-testid="stepper-previous"
                  >
                    Previous
                  </Button>
              }
            </Col>
            <Col md={12} className="text-right">
              {
                selectedTab !== detailNav.length - 1 && commonTabNavigationEnabled &&
                  <Button
                    type="primary"
                    htmlType="submit"
                    data-testid="stepper-next"
                  >
                    Next
                  </Button>
              }
            </Col>
          </Row>
        </Form>}
    </div>
  </React.Fragment>;
};

export default CustomFormStepper;
